

var galleryCaptionPro = new Swiper("[data-pro-video-slider]", {
  speed: 500,
  slidesPerView: "auto",
  simulateTouch: true,
  spaceBetween: 20,
  navigation: {
    nextEl: ".video-next",
    prevEl: ".video-prev",
  }, 
});





const playIcons = document.querySelectorAll('[data-pro-video-slider] .cc-video-overlay');

playIcons.forEach((element) => {
  element.addEventListener('click', (event) => {
    console.log(event);
    const videoItem = event.target.closest('.cc-video-wrapper');
    if (videoItem) {
      // Find all videos and pause any that are playing
      document.querySelectorAll('.cc-video-wrapper video').forEach((video) => {
        if (!video.paused) {
          video.pause();
          video.controls = false; // Hide controls for paused videos
           
           document.querySelectorAll('.cc-video-slider .swiper-slide').forEach((el) => {
            el.classList.remove('active-slide');
            el.classList.remove('active-slide-play');
          });
        }
      });

      // Hide the play button for the clicked video and play it
      
      const video = videoItem.querySelector('video');
      if (video) {
        video.controls = true; // Show controls for the active video
        video.play();
      }

      // Update active slide
      document.querySelectorAll('.cc-video-slider .swiper-slide').forEach((el) => {
        el.classList.remove('active-slide');
        el.classList.remove('active-slide-play');
      });
      event.currentTarget.closest('.swiper-slide').classList.add('active-slide');
      event.currentTarget.closest('.swiper-slide').classList.add('active-slide-play');
    }
  });
});



let styleSelect = document.querySelector('.product-style-wrapper .option_txt');
if (styleSelect) {
  styleSelect.addEventListener('click', (event) => {
    event.target.closest('.product-style-wrapper').classList.toggle('open');
  });
}

// Get references to all necessary elements
let styleLI= document.querySelectorAll('.style-dropdwon-menu li');
let floralProduct = document.querySelector('.floral-products');
let solidProduct = document.querySelector('.solid-products');
let patternProduct = document.querySelector('.pattern-products');
let natureProduct = document.querySelector('.nature-products');

let joggerProduct = document.querySelector('.jogger-set-products');
let sweetdreamsProduct = document.querySelector('.newborn-set-products');
let littlesleeperProduct = document.querySelector('.sleeper-products');

// Add a click event listener to each label
styleLI.forEach(li => {
    li.addEventListener('click', (event) => {
        let label = event.target.closest('li').querySelector('label');
        // Get the associated input element
        let associatedInput = document.querySelector(`#${label.getAttribute('for')}`);

        // Set the input as checked
        associatedInput.checked = true;
        event.target.closest('.product-style-wrapper').classList.remove('open');

        // Get the selected value
        let selectedValue = associatedInput.value;
        event.target.closest('.product-style-wrapper').querySelector('.option_txt').innerHTML = selectedValue;
        // Hide all product divs initially
        floralProduct.classList.add('d-none');
        solidProduct.classList.add('d-none');
        patternProduct.classList.add('d-none');
        natureProduct.classList.add('d-none');
 
        joggerProduct.classList.add('d-none');
        sweetdreamsProduct.classList.add('d-none');
        littlesleeperProduct.classList.add('d-none');

        // Show the corresponding div based on the selected value
        switch (selectedValue) {
            case 'floral':
                floralProduct.classList.remove('d-none');
                break;
            case 'solid':
                solidProduct.classList.remove('d-none');
                break;
            case 'pattern':
                patternProduct.classList.remove('d-none');
                break;
            case 'nature':
                natureProduct.classList.remove('d-none');
             break;
            
            case 'jogger-set':
                joggerProduct.classList.remove('d-none');
                break;
            case 'newborn-set':
                sweetdreamsProduct.classList.remove('d-none');
                break;
            case 'sleeper':
                littlesleeperProduct.classList.remove('d-none');
                break;
            default:
                console.warn('Unexpected selection:', selectedValue);
                break;
        }

    });
});



//let styleSelect = document.querySelector('.product-style-wrapper select');
// let floralProduct = document.querySelector('.floral-products');
// let solidProduct = document.querySelector('.solid-products');
// let patternProduct = document.querySelector('.pattern-products');
// let natureProduct = document.querySelector('.nature-products');

// Add an event listener to the select dropdown
// styleSelect.addEventListener('change', () => {
//     // Get the selected option value
//     let selectedValue = styleSelect.value;

//     // Hide all product divs initially
//     floralProduct.classList.add('d-none');
//     solidProduct.classList.add('d-none');
//     patternProduct.classList.add('d-none');
//     natureProduct.classList.add('d-none');

//     // Show the corresponding div based on the selected value
//     switch (selectedValue) {
//         case 'floral':
//             floralProduct.classList.remove('d-none');
//             break;
//         case 'solid':
//             solidProduct.classList.remove('d-none');
//             break;
//         case 'pattern':
//             patternProduct.classList.remove('d-none');
//             break;
//         case 'nature':
//             natureProduct.classList.remove('d-none');
//             break;
//         default:
//             // Optionally handle cases where no match is found
//             console.warn('Unexpected selection:', selectedValue);
//             break;
//     }
// });




// let playIcons = document.querySelectorAll('.cc-video-overlay');

// playIcons.forEach((playIcon) => {
//   playIcon.addEventListener('click', (event) => {
//     const videoItem = event.target.closest('.cc-video-wrapper');
//     if (videoItem) {
//       // Find the video inside the clicked wrapper
//       const video = videoItem.querySelector('video');
      
//       // If there's a currently playing video, pause it and reset controls
//       document.querySelectorAll('.cc-video-wrapper video').forEach((vid) => {
//         if (vid !== video && !vid.paused) {
//           vid.pause();
//           vid.controls = false;
//         }
//       });

//       // Check if the current video is already playing
//       if (video.paused) {
//         video.play();
//         video.controls = true; // Show controls for active video
//       } else {
//         video.pause();
//         video.controls = false; // Hide controls if video is paused
//       }

//       // Update active slide classes
//       document.querySelectorAll('.cc-video-slider .swiper-slide').forEach((slide) => {
//         slide.classList.remove('active-slide', 'active-slide-play');
//       });

//       // Apply active classes only if the video is playing
//       if (!video.paused) {
//         const slide = event.currentTarget.closest('.swiper-slide');
//         slide.classList.add('active-slide', 'active-slide-play');
//       }
//     }
//   });
// });





$('.cc-content-img .cc-content-wrap').click(function(){
  $(this).toggleClass('active');
  $(this).siblings('.cc-content-wrap-ans').slideToggle();
})

var init = false;
var imagesSlider;
function swiperCard() {
  if (window.innerWidth <= 575) {
    if (!init) {
      init = true;
      imagesSlider = new Swiper(".cc-images-slider", {
        slidesPerView: "auto",
        spaceBetween: 3,
        grabCursor: true,
        keyboard: true,
        autoHeight: false, 
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });
    }
  } else if (init) {
    imagesSlider.destroy();
    init = false;
  }
}
swiperCard();
window.addEventListener("resize", swiperCard);

$(document).ready(function(){
    $(".cc-accordion .cc-accordion-title").click(function () {
    $(this)
      .toggleClass("active")
      .next(".cc-accordion-tab")
      .slideToggle()
      .parent()
      .siblings()
      .find(".cc-accordion-tab")
      .slideUp()
      .prev()
      .removeClass("active");
  });
  $(".nav-tab-links button").click(function () {
    $(".nav-tab-links button").removeClass("active");
    $(this).addClass("active");
    var dataId = $(this).data("id");
    $(".tab-content").removeClass("active").addClass("hide");
    $("#" + dataId)
      .addClass("active")
      .removeClass("hide");
  });
})

document.querySelectorAll('.template-product .cc-btn').forEach((btn) => {
  btn.addEventListener('click', (event) => {
    event.preventDefault(); // Optional: prevent the default button action
    document.querySelector('.ProductForm__AddToCart').click();
  
  });
});


const dateElement = document.querySelector("[data-date]");

// Get the current date
const currentDate = new Date();

// Calculate the start and end dates
const startDate = new Date(currentDate);
startDate.setDate(currentDate.getDate() + 6); // Add 6 days to today's date

const endDate = new Date(startDate);
endDate.setDate(startDate.getDate() + 4); // Add 4 days to the start date

// Format dates
const startDateFormatted = startDate.toLocaleDateString('en-US', { day: 'numeric', month: 'short' });
const endDateFormatted = endDate.toLocaleDateString('en-US', { day: 'numeric', month: 'short' });

// Update the content of the HTML element
dateElement.innerHTML = `${startDateFormatted} - ${endDateFormatted}`;
